import React, { useState, useEffect } from 'react';
import './CaseForm.scss';
import { useParams } from 'react-router-dom';
import { DistrictCourtCaseForm } from '../DistrictCourtCaseForm/DistrictCourtCaseForm';
import { HighCourtCaseForm } from '../HighCourtCaseForm/HighCourtCaseForm';
import { OtherCourtCaseForm } from '../OtherCourtCaseForm/OtherCourtCaseForm';

export const CaseForm = () => {
  const { courtType: routeCourtType, courtRef } = useParams(); // Get both courtType and courtRef
  const [courtType, setCourtType] = useState('high');
  
  // Determine if this is edit mode
  const isEdit = !!courtRef;

  // Set court type based on route parameter
  useEffect(() => {
    if (routeCourtType) {
      setCourtType(routeCourtType);
    }
  }, [routeCourtType]);

  const handleCourtTypeChange = (e) => {
    setCourtType(e.target.value);
  };

  return (
    <div className="case-form-container">
      <div className={`court-type-selection ${isEdit ? 'court-edit-case' : '' }`}>
        <div className='new-court-case'>
          {!isEdit && (
            <div className='two-court-cases'>
              <label className={courtType === 'high' ? 'active' : ''}>
                <input
                  type="radio"
                  value="high"
                  checked={courtType === 'high'}
                  onChange={handleCourtTypeChange}
                />
                <span>High Court</span>
              </label>
              <label className={courtType === 'district' ? 'active' : ''}>
                <input
                  type="radio"
                  value="district"
                  checked={courtType === 'district'}
                  onChange={handleCourtTypeChange}
                />
                <span>District Court</span>
              </label>
              <label className={courtType === 'other' ? 'active' : ''}>
                <input
                  type="radio"
                  value="other"
                  checked={courtType === 'other'}
                  onChange={handleCourtTypeChange}
                />
                <span>Other Court</span>
              </label>
            </div>
          )}
        </div>
      </div>

      <div className="form-content">
        {courtType === 'district' && <DistrictCourtCaseForm isEdit={isEdit} />}
        {courtType === 'high' && <HighCourtCaseForm isEdit={isEdit} />}
        {courtType === 'other' && <OtherCourtCaseForm isEdit={isEdit} />}
      </div>
    </div>
  );
};